import { render } from "./BasicColumnChartCallDurationsWaitingTime.vue?vue&type=template&id=60044f6d"
import script from "./BasicColumnChartCallDurationsWaitingTime.vue?vue&type=script&lang=js"
export * from "./BasicColumnChartCallDurationsWaitingTime.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__